import { all, takeEvery, put, call } from "redux-saga/effects";
import { notification } from "antd";
import {
  getAllUsersFromMyMenuRequest,
  getAllDiscountsRequest,
  appendDiscountsRequest,
  removeDiscountsRequest,
  getDiscountsReferencesRequest,
} from "../../services/discountService";
import { getToken } from "../../utils/utility";
import actions from "./actions";

export function* getAllUsersFromMyMenu() {
  const token = getToken().get("idToken");

  if (token) {
    const response = yield call(getAllUsersFromMyMenuRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_ALL_USERS_FROM_MYMENU_SUCCESS,
        myMenuUsers: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  }
}

export function* getAlDiscounts() {
  const token = getToken().get("idToken");

  if (token) {
    const response = yield call(getAllDiscountsRequest, token);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_ALL_DISCOUNTS_SUCCESS,
        allDiscounts: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  }
}

export function* appendDiscounts(data) {
  const token = getToken().get("idToken");

  if (token) {
    const response = yield call(appendDiscountsRequest, token, data);
    if (response[0] === 200) {
      yield put({
        type: actions.APPEND_DISCOUNTS_SUCCESS,
        discount: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Няма конфигуриран екпорт код за тази отстъпка",
        description: msg,
      });
    }
  }
}

export function* removeDiscounts(data) {
  const token = getToken().get("idToken");

  if (token) {
    const response = yield call(removeDiscountsRequest, token, data);
    if (response[0] === 200) {
      yield put({
        type: actions.REMOVE_DISCOUNTS_SUCCESS,
        data: data,
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  }
}

export function* getDiscountsReferences({ startDate, endDate }) {
  const token = getToken().get("idToken");

  if (token) {
    const response = yield call(
      getDiscountsReferencesRequest,
      token,
      startDate,
      endDate
    );

    if (response[0] === 200) {
      yield put({
        type: actions.GET_DISCOUNTS_REFERENCES_SUCCESS,
        discountReferences: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Няма конфигуриран екпорт код за тази отстъпка",
        description: msg,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(
      actions.GET_ALL_USERS_FROM_MYMENU_REQUEST,
      getAllUsersFromMyMenu
    ),
    yield takeEvery(actions.GET_ALL_DISCOUNTS_REQUEST, getAlDiscounts),
    yield takeEvery(actions.APPEND_DISCOUNTS_REQUEST, appendDiscounts),
    yield takeEvery(actions.REMOVE_DISCOUNTS_REQUEST, removeDiscounts),
    yield takeEvery(
      actions.GET_DISCOUNTS_REFERENCES_REQUEST,
      getDiscountsReferences
    ),
  ]);
}
